import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';

// models
import { HighlightOptionsValue, IHighlightOption } from '../../services/highlight-products.service';
import { PanelHeaderTitle } from '../../services/side-panel.service';

//service
import { SidePanelService } from '../../services/side-panel.service';
import { HighlightProductsService } from '../../services/highlight-products.service';
import { Subscription } from 'rxjs';

import { SHARED_MODULES } from '../../../shared.';

@Component({
    selector: 'app-highlight-options',
    templateUrl: './highlight-options.component.html',
    styleUrls: ['./highlight-options.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class HighlightOptionsComponent implements OnInit, OnDestroy {

	formControl: FormControl<HighlightOptionsValue>;
	highlightOptions: Array<IHighlightOption> = new Array<IHighlightOption>();
	subscriptions: Array<Subscription> = [];

	@Input() activeValue: HighlightOptionsValue;

	@Output('apply') onApplyEmitter: EventEmitter<HighlightOptionsValue> = new EventEmitter<HighlightOptionsValue>();

	constructor(
		private formBuilder: FormBuilder,
		private highlightProductsService: HighlightProductsService,
		private sidePanelService: SidePanelService
	) {}

	ngOnInit(): void {
		this.sidePanelService.title = PanelHeaderTitle.ProductsHighlights;
		this.sidePanelService.disabledApply = true;

		this.highlightOptions = this.highlightProductsService.highlightOptions;
		this.formControl = this.formBuilder.control<HighlightOptionsValue>(this.activeValue);
		this.formControl.valueChanges.subscribe(() => {
			this.sidePanelService.disabledApply = false;
		});

		this.subscriptions.push(
			this.sidePanelService.applySubject.subscribe(() => {
				this.onApplyEmitter.emit(this.formControl.value);
			}),

			this.sidePanelService.cancelSubject.subscribe(() => {
				this.onApplyEmitter.emit(HighlightOptionsValue.Empty);
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}
}
